import api from './api';

// Managed lookup of marketplace action codes (grouped by category). Superadmin admin API.
const marketplaceActionTypesService = {
  list: async () => (await api.get('/admin/marketplace-action-types')).data,
  get: async (id) => (await api.get(`/admin/marketplace-action-types/${id}`)).data,
  create: async (data) => (await api.post('/admin/marketplace-action-types', data)).data,
  update: async (id, data) => (await api.put(`/admin/marketplace-action-types/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/admin/marketplace-action-types/${id}`)).data,
};

export default marketplaceActionTypesService;
